<template>
  <div class="account-profile">
    <div :class="{ error: isClickNext && !form.open_user_info.email }" class="ipt-box">
      <div class="ipt-main email">
        <div class="val-box">
          <span v-if="form.open_user_info.email" class="label">{{ $t('accountProfile.a000001') }}</span>
          <Field :disabled="!isCanChange && extra_update_status != 1" v-model="form.open_user_info.email" class="val" :placeholder="$t('accountProfile.a000001')" @input="handEmailSuffix" @blur="blurEvent"></Field>
        </div>
        <!-- 邮箱弹窗 -->
        <Overlay :show="emailSuffixShow" class="overlay" :style="{ top: topDistance + 'px', width: dialogWidth + 'px' }" :lock-scroll="false"  @click="emailSuffixShow = false" >
          <div class="symbolList-box">
            <div v-for="item in emailSuffixList" :key="item" @click="handSuffixClick(item)" class="cell-box">
              {{ item }}
            </div>
          </div>
        </Overlay>
      </div>
      <p v-if="isClickNext && !form.open_user_info.email" class="error">{{ $t('accountProfile.a000002') }}</p>
    </div>

    <div class="ipt-box" :class="{error: isClickNext && !form.address.nationality_or_region_name}">
      <div class="ipt-main">
        <div class="val-box" @click="checkCountryDialog">
            <span class="label" :class="{ placeholder: !form.address.nationality_or_region_name }"
            >{{ $t('openAccount.t000063') }}</span
            >
          <span class="val" v-if="form.address.nationality_or_region_name">{{
              form.address.nationality_or_region_name
            }}</span>
        </div>
        <span class="icon-arrow"></span>
      </div>
      <p class="error">{{ $t('openAccount.t000064') }}</p>
    </div>

    <div class="ipt-box" :class="{error: isClickNext && !form.address.province_name}">
      <div class="ipt-main" v-if="![1,2, '1', '2'].includes(Number(form.address.nationality_or_region_code))">
        <div class="val-box">
          <span v-if="form.address.otherAffiliation" class="label">{{ $t('accountProfile.a000003') }}<span v-if="form.address.nationality_or_region_code  != 1">({{$t('openAccount.t000128')}})</span></span>
          <Field
            v-model="form.address.otherAffiliation"
            class="val"
            :formatter="formatVal"
            :disabled="!isCanChange && extra_update_status != 1"
            :placeholder="form.address.nationality_or_region_code  != 1 ? $t('accountProfile.a000003') + `(${$t('openAccount.t000128')})` : $t('accountProfile.a000003')"
          ></Field>
        </div>
      </div>
      <div class="ipt-main" v-else>
        <div class="val-box" @click="openAreaPopup">
            <span class="label" :class="{ placeholder: !form.address.province_name }"
            >{{ $t('accountProfile.a000003') }}<span v-if="form.address.nationality_or_region_code  != 1">({{$t('openAccount.t000128')}})</span></span
            >
          <span class="val" v-if="form.address.province_name">{{ getFullAddress() }}</span>
        </div>
        <span class="icon-arrow"></span>
      </div>
      <p class="error"
         v-if="(![1,2, '1', '2'].includes(Number(form.address.nationality_or_region_code)) && !form.address.otherAffiliation) || (!form.address.province_name)">
        {{ $t('accountProfile.a000004') }}</p>
    </div>
    <div
      :class="{ error: isClickNext && !form.address.detail_address }"
      class="ipt-box"
    >
      <div class="ipt-main">
        <div class="val-box">
          <span v-if="form.address.detail_address" class="label">{{ $t('accountProfile.a000005') }} <span v-if="form.address.nationality_or_region_code  != 1">({{$t('openAccount.t000128')}})</span></span>
          <Field
            v-model="form.address.detail_address"
            class="val"
            :formatter="formatVal"
            :disabled="!isCanChange && extra_update_status != 1"
            :placeholder="form.address.nationality_or_region_code  != 1 ? $t('accountProfile.a000005') + `(${$t('openAccount.t000128')})` : $t('accountProfile.a000005')"
          ></Field>
        </div>
      </div>
      <p v-if="isClickNext && !form.address.detail_address" class="error">
        {{ $t('accountProfile.a000006') }}
      </p>
    </div>
    <div class="address-box ipt-box" :class="{ error: isClickNext && !addressImgBase64 }">
      <p class="title">{{ $t('accountProfile.a000007') }}</p>
      <UploadImg
        :icon="beforeIcon"
        :text="$t('accountProfile.a000007')"
        :img="addressImgBase64"
        @afterRead="afterRead"
        @del="delImg"
      />
      <p class="error">{{ $t('openAccount.t000129') }}</p>
    </div>
    <div :class="{ error: isClickNext && !educationToText }" class="ipt-box">
      <div class="ipt-main" @click="openActions('education')">
        <div class="val-box">
          <span :class="{ placeholder: !form.education }" class="label"
            >{{ $t('accountProfile.a000008') }}</span
          >
          <span v-if="educationToText" class="val">{{ educationToText }}</span>
        </div>
        <span class="icon-arrow"></span>
      </div>
      <p class="error">{{$t('accountProfile.a000009')}}</p>
    </div>
    <div :class="{ error: isClickNext && !form.open_user_info.job_type }" class="ipt-box">
      <div class="ipt-main" @click="openActions('job_type')">
        <div class="val-box">
          <span :class="{ placeholder: !form.open_user_info.job_type }" class="label"
            >{{ $t('accountProfile.a000010') }}</span
          >
          <span v-if="form.open_user_info.job_type" class="val">{{ jobTypeToText }}</span>
        </div>
        <span class="icon-arrow"></span>
      </div>
      <p class="error">{{ $t('accountProfile.a000011') }}</p>
    </div>
<!--    职业不同显示 内容不同-->
    <!--    受雇 + 自雇 -->
    <template v-if="form.open_user_info.job_type == 1 || form.open_user_info.job_type == 2">
      <div
        class="ipt-box"
        :class="{ error: isClickNext && !form.open_user_info.company }"
      >
        <div class="ipt-main">
          <div class="val-box">
            <span v-if="form.open_user_info.company" class="label">{{ $t('accountProfile.a000012') }}</span>
            <Field
              v-model="form.open_user_info.company"
              class="val"
              :disabled="!isCanChange && extra_update_status != 1"
              :placeholder="$t('accountProfile.a000012')"
            ></Field>
          </div>
        </div>
        <p class="error">{{ $t('personalInformation.error_tip.lang2') }}</p>
      </div>

      <div
        class="ipt-box"
        :class="{ error: isClickNext && !form.open_user_info.vocation }"
      >
        <div class="ipt-main">
          <div class="val-box">
            <span v-if="form.open_user_info.vocation" class="label">{{ $t('accountProfile.a000016') }}</span>
            <Field
              v-model="form.open_user_info.vocation"
              class="val"
              :disabled="!isCanChange && extra_update_status != 1"
              :placeholder="$t('accountProfile.a000016')"
            ></Field>
          </div>
        </div>
        <p class="error">{{ $t('personalInformation.error_tip.lang6') }}</p>
      </div>
      <div :class="{ error: isClickNext && !form.open_user_info.vocation_attribute }" class="ipt-box">
        <div class="ipt-main" @click="openActions('vocation_attribute')">
          <div class="val-box">
          <span :class="{ placeholder: !form.open_user_info.vocation_attribute }" class="label"
          >{{ $t('accountProfile.a000014') }}</span
          >
            <span v-if="form.open_user_info.vocation_attribute" class="val">{{ vocationAttributeToText }}</span>
          </div>
          <span class="icon-arrow"></span>
        </div>
        <p class="error">{{ $t('personalInformation.error_tip.lang4') }}</p>
      </div>
    </template>
    <!--    其他-->
    <template v-if="form.open_user_info.job_type == 5">
      <div :class="{ error: isClickNext && !form.open_user_info.job_type_other_describe }" class="ipt-box">
        <div class="ipt-main" @click="openActions('job_type_other_describe')">
          <div class="val-box">
          <span :class="{ placeholder: !form.open_user_info.job_type_other_describe }" class="label"
          >{{ $t('accountProfile.a000024') }}</span
          >
            <span v-if="form.open_user_info.job_type_other_describe" class="val">{{ jobTypeOtherDescribeToText }}</span>
          </div>
          <span class="icon-arrow"></span>
        </div>
        <p class="error">{{ $t('accountProfile.a000025') }}</p>
      </div>

    </template>
    <template v-for="(item, index) in financialSituation">
      <template v-if="index < 3">
        <div :class="{ error: isClickNext && !item.value }" class="ipt-box">
          <div
            class="ipt-main"
            @click="openActions('financialSituation_' + index, item.options, index)"
          >
            <div class="val-box">
            <span :class="{ placeholder: !item.value }" class="label">{{
                item.label
              }}</span>
              <span v-if="item.value" class="val">{{ financialSituationValueText(item.value, item.options) }}</span>
            </div>
            <span class="icon-arrow"></span>
          </div>
        </div>
      </template>
      <!-- 资金来源模块 -->
      <div class="funding-source ipt-box" v-if="index == 3" :class="{ error: item.value.length <= 0 && isClickNext }">
        <div class="subTitle">{{ item.label }}</div>
        <van-checkbox-group class="checkbox-container"
                            v-model="item.value" @change="fundSourceChange">
          <div class="checkbox-item" v-for="cItem in item.options" :key="cItem.value">
            <van-checkbox :disabled="!isCanChange && extra_update_status != 1" :name="cItem.value" shape="square">
              <template #icon="props">
                <img class="img-icon" :src="props.checked ? Checkd : CheckNone" />
              </template>
              {{ cItem.text }}
            </van-checkbox>
          </div>
        </van-checkbox-group>
        <p class="error">{{ $t('suitabilitySurvey.s000003') }}</p>
        <!-- 其他输入框 -->

        <div
          v-if="item.value.includes(6)"
          :class="{ errorBox: isClickNext && !item.options[item.options.length - 1].inputValue }"
          class="ipt-box"
        >
          <div class="ipt-main">
            <div class="val-box">
              <span v-if="item.options[item.options.length - 1].inputValue" class="label">{{ $t('suitabilitySurvey.otherSourcesOfFunds') }}</span>
              <Field v-model="item.options[item.options.length - 1].inputValue"
                class="val"
                :disabled="!isCanChange && extra_update_status != 1"
                :placeholder="$t('suitabilitySurvey.otherSourcesOfFunds')"
              ></Field>
            </div>
          </div>
          <p class="error">{{ $t('suitabilitySurvey.s000003') }}</p>
        </div>
      </div>
      <!-- 住宅模块 -->
<!--      <div class="residence ipt-box" v-if="index == 4" :class="{ error: !validateAssetAllocation &&  isClickNext }">-->
<!--        <div class="subTitle">{{ item.label }}</div>-->
<!--        <div class="residence-options">-->
<!--          <div class="option-group" v-for="(cItem, cIndex) in item.options" :key="cIndex">-->
<!--            <van-radio-group class="mainRadio" v-model="item.value" :disabled="!isCanChange && extra_update_status != 1">-->
<!--              <van-radio icon-size="15px" shape="square" :name="cItem.value" @click="changeResidence">-->
<!--                <template #icon="props">-->
<!--                  <img class="img-icon" :src="props.checked ? Checkd : CheckNone" />-->
<!--                </template>-->
<!--                {{ cItem.text }}</van-radio>-->
<!--            </van-radio-group>-->

<!--            <van-radio-group v-model="cItem.children.value" :disabled="item.value !== cItem.value || (!isCanChange && extra_update_status != 1)">-->
<!--              <van-radio icon-size="15px" v-for="(ccItem, ccIndex) in cItem.children.options" :key="`${cIndex}-${ccIndex}`"-->
<!--                         class="subRadio" :name="ccItem.value">-->
<!--                <template #icon="props">-->
<!--                  <img class="img-icon" :src="props.checked ? RadioCheck : RadioNone" />-->
<!--                </template>-->
<!--                {{ ccItem.label }}-->
<!--              </van-radio>-->
<!--            </van-radio-group>-->
<!--          </div>-->
<!--        </div>-->
<!--        <p class="error">{{ $t('suitabilitySurvey.s000004') }}</p>-->
<!--      </div>-->
    </template>
    <!-- 资金来源-->
    <NavButtons
      @on-next="next"
      :prev-text="$t('accountProfile.a000026')"
      :next-text="$t('accountProfile.a000027')"
      navigation-type="push"
      :disabled="computeButtonDisabled"
      :show-prev="!isCanChange && extra_update_status != 1"
      @on-prev="toChangeInfo"
      />

    <!--    下拉选择 -->
    <van-popup v-model="isShowPicker" position="bottom" class="picker-popup picker-ui">
      <van-picker
        :columns="pickerActions"
        :default-index="currentDefaultIndex"
        show-toolbar
        @cancel="isShowPicker = false"
        @confirm="onEducationalConfirm"
      />
    </van-popup>
    <!--    地址选择 省市县 -->
    <van-popup v-model="showAreaPopup" position="bottom" class="address-popup picker-ui">
      <van-area :value="form.address.country_code || form.address.city_code || form.address.province_code" :area-list="areaList" @cancel="showAreaPopup = false" @confirm="confirmArea"></van-area>
    </van-popup>

    <!--    密码确认 -->
    <!-- <van-dialog
      class="check-password-dialog"
      v-model="checkPasswordShow"
      :before-close="beforeClose"
      @cancel="checkPasswordShow = false"
      @closed="checkPassword = ''"
      @open="checkPassword = ''"
      @confirm="confirm"
      :cancelButtonText="$t('fail_reason.cancel')"
      :confirm-button-text="$t('fail_reason.confirm')"
      :title="$t('fail_reason.checkPassword')"
      :showCancelButton="true"
    >
      <customField
        ref="custom-field-password"
        class="custom-field-box"
        type="password"
        :open-eye-function="true"
        v-model="checkPassword"
      ></customField>
    </van-dialog> -->

    <!-- 验证登录密码弹窗 -->
    <van-dialog v-model="checkPasswordShow"
      class="check-password-dialog"
      :title="$t('fail_reason.checkPassword')" show-cancel-button
      :before-close="handleBeforeClose">
      <div class="verifyLoginPassword">
        <Field class="input" v-model="checkPassword" :type="eyeIsOpen ? 'text' : 'password'" >
          <template #button>
            <template v-if="!eyeIsOpen">
              <img
                src="@/assets/images/open-account/light_close.png"
                class="eye lightClose"
                @click="eyeSwitch"
              >
              <img
                src="@/assets/images/open-account/dark_close.png"
                class="eye darkClose"
                @click="eyeSwitch"
              >
            </template>
            <template v-else>
              <img
                src="@/assets/images/open-account/light_open.png"
                class="eye lightOpen"
                @click="eyeSwitch"
              >
              <img
                src="@/assets/images/open-account/dark_open.png"
                class="eye darkOpen"
                @click="eyeSwitch"
              >
            </template>
          </template>
        </Field>
      </div>
    </van-dialog>

    <!--    密码错误-->
    <password-error-prompt
      v-show="pwdErrPromptOption.show"
      :err-code="pwdErrPromptOption.errCode"
      :err-html="pwdErrPromptOption.errHtml"
      @password-error-prompt-confirm="passwordErrorPromptConfirm"
      ref="password-error-prompt-el"
    ></password-error-prompt>

    <!--    选择国籍弹窗 -->
    <van-popup
      v-model="checkCountryNameDialog"
      :showConfirmButton="false"
      :class="bgColor == 'black-theme' ? 'darkOrLight' : 'check-country'"
      getContainer="body"
      position="right"
    >
      <div class="dialog-head">
        <a class="btn-back" @click="checkCountryNameDialog = false"></a>
        <p class="dialog-title">{{$t('openAccount.t000096')}}</p>
      </div>
      <div class="input-box">
        <Field
          v-model="checkCountryKeyWord"
          left-icon="search"
          :placeholder="$t('openAccount.t000097')"
        ></Field>
      </div>
      <div class="list">
        <div class="list-main">
          <template v-for="item in countryNameList">
            <div
              v-if="
                !checkCountryKeyWord ||
                  item.name.indexOf(checkCountryKeyWord) >= 0
              "
              @click="checkCountry(item)"
              class="item"
              :class="{ cur: form.country_code == item.id }"
              :key="item.id"
            >
              <span>{{ item.name }}</span>
              <Icon
                v-show="form.country_code == item.id"
                name="success"
                color="#ff9275"
              />
            </div>
          </template>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import {
  Area,
  Checkbox,
  CheckboxGroup,
  Dialog,
  Field,
  Picker as VanPicker,
  Popup as VanPopup,
  Radio,
  RadioGroup,
  Toast,
  Overlay, Icon
} from "vant";
import NavButtons from "@/views/open-account/components/navButtons.vue";
import UploadImg from "@/views/open-account/components/UploadImg.vue";
import beforeIcon from "@/assets/images/id-card-upload-before.png";
import passwordErrorPrompt from "@/components/passwordErrorPrompt.vue";
import customField from "@/components/customField/index.vue";
import { closeWebView } from "@/utils/hybirdMethods";
import RadioNone from '@/assets/images/open-account/radio.png'
import RadioCheck from '@/assets/images/open-account/radio_check.png'
import CheckNone from '@/assets/images/open-account/check_none.png'
import Checkd from '@/assets/images/open-account/check.png'
import { isEmail } from '@/utils/verify'

export default {
  components: {
    Icon,
    customField,
    passwordErrorPrompt, UploadImg, VanPicker, VanPopup, NavButtons, Field, [Area.name]: Area,
    [Checkbox.name]: Checkbox,
    [CheckboxGroup.name]: CheckboxGroup,
    [Radio.name]: Radio,
    [Dialog.Component.name]: Dialog.Component,
    [RadioGroup.name]: RadioGroup,
    Overlay
  },
  computed: {
    bgColor() {
      return this.$store.getters["common/bgColor"];
    },
    financialSituationValueText(){
      return (val, options) => {
        const item = options.find(i => i.value == val);
        return item.text;
      }
    },
    jobTypeToText(){
      const { job_type } = this.form.open_user_info;
      const item = this.$t("personalInformation.employment_field.columns").find(i => i.value == job_type);
      return item.text;
    },

    vocationAttributeToText(){
      const { vocation_attribute } = this.form.open_user_info;
      const item = this.careerAttributesList.find(i => i.value == vocation_attribute);
      return item ? item.text : vocation_attribute;
    },

    jobTypeOtherDescribeToText(){
      const { job_type_other_describe } = this.form.open_user_info;
      const item = this.careerDescriptionList.find(i => i.value == job_type_other_describe);
      return item ? item.text : job_type_other_describe;
    },
    educationToText(){
      const { education } = this.form.open_user_info;
      if(!education) return '';
      const item = this.$t("personalInformation.education_field.columns").find(i => i.value == education);
      return item.text;
    },
    jobAgeToText(){
      const { job_age } = this.form.open_user_info;
      if(!job_age) return '';
      const item = this.$t("personalInformation.employment_duration_field.columns").find(i => i.value == job_age);
      return item.text;
    },
    // 校验金融产品选择情况
    validateFinancialProducts() {
      const item = this.financialSituation[this.financialSituation.length - 2];
      if (item.value.length <= 0) return false;
      // if (item.value.includes(6) && !item.options.slice(-1)[0].inputValue) return false;
      return true;
    },
    // 校验资产配置情况
    validateAssetAllocation() {
      const item = this.financialSituation[this.financialSituation.length - 1];
      return item.options.some(option => typeof option.children.value == 'number');
    },
    computeButtonDisabled() {
      let isDisabled = false;

      // 校验个人信息必填字段
      const validatePersonalFields = () => {
        let requiredFields = ['email', 'education'];

        // 根据职业类型判断必填字段
        if (this.form.open_user_info.job_type && [1, 2, '1', '2'].includes(this.form.open_user_info.job_type)) {
          requiredFields = ['company', 'vocation_attribute', 'vocation',  'email', 'education'];
        }

        return requiredFields.every(field => this.form.open_user_info[field]);
      }
      // 大陆 + 香港  国籍+地址归属(3个) + 详细信息
      // 非大陆+香港  国籍 + 归属(输入) + 详细(输入)
      // 校验地址信息
      const validateAddressFields = () => {

        const fields =
          [1,2].includes(Number(this.form.address.nationality_or_region_code))
          ? ['province_code', 'city_code', 'country_code']
          : ['otherAffiliation']

        return fields.every(field => !!this.form.address[field]);
      }
      const hasDetails = this.form.address.detail_address ? true : false;

      // 校验其他职业描述
      const validateOtherJobType = () => {
        return !(this.form.open_user_info.job_type == 5 && !this.form.open_user_info.job_type_other_describe);
      }
      
      // 综合判断所有条件
      return  !validatePersonalFields() ||
                  !validateAddressFields() ||
                  !validateOtherJobType() ||
                  !this.validateFinancialProducts ||  // 金融产品选择判断
                  !this.validateAssetAllocation ||    // 资产配置判断
                  !this.form.address_img || !hasDetails;

      return isDisabled;
    }

  },
  data() {
    this.resultEmail = '';
    return {
      checkCountryKeyWord: '',
      countryNameList: '',
      RadioNone,
      RadioCheck,
      CheckNone,
      Checkd,
      beforeIcon,
      topDistance: 0,
      dialogWidth: 0,
      isCanChange: false, // 是否可以修改
      isClickNext: false,
      addressImgBase64: '',
      open_status: 0,
      emailSuffixShow: false,     // 控制邮箱弹窗
      currentDefaultIndex: 0,
      eyeIsOpen: false,        // 是否明文显示密码
      checkPassword: '',          //  密码输入
      form: {
        address: {
          city_code: "",
          city_name: "",
          country_code: "",
          country_name: "",
          detail_address: "",
          province_code: "",
          province_name: "",
          otherAffiliation: "",
          nationality_or_region_name: "",
          nationality_or_region_code: ""
        },
        open_user_info: {
          education: '',
          company: "",
          company_address: "",
          company_phone: "",
          email: "",
          job_age: 0,
          job_type: "1",
          job_type_other_describe: "",
          vocation: "",
          vocation_attribute: ""
        },
        address_img: '',
        derivative: {},
      },
      financialSituation: [
        ...this.$t("suitabilitySurvey.financial_list"),
        this.$t('suitabilitySurvey.fundSource'),
        this.$t('suitabilitySurvey.homeTenure')
      ],
      isShowPicker: false,
      pickerActionsKey: "",
      pickerActions: [],
      areaList: [],
      showAreaPopup: false,
      checkPasswordShow: false,
      pwdErrPromptOption: {
        show: false,
        errCode: -1,
        errHtml: ""
      },
      extra_update_status:'',
      // 是否存在修改资料待审核（us_users_profile_info_record.extra_update_status=0）：0否 1是
      pending_profile: '',
      // 待审核修改资料来源：0无待审；1=App提交；2=后台提交
      pending_commit_source: '',
      // 修改资料覆盖选择：''无选择；'1'=覆盖(是)；'2'=不覆盖(否)，后续提交给后端
      pending_cover_choice: '',
      emailSuffixList: '',
      careerAttributesList: [],
      careerDescriptionList:[],
      checkCountryNameDialog: false
    };
  },
  async created() {
    // 为true就渲染被拒的账户资料否则使用首开的数据
    if ( this.$route.query.isEdit ) {
      this.countryNameList = await this.$apis.getAllCountryList();
      this.getAuditMaterials();
    } else {
      this.getData()
    }
    this.getCareerAttributesEnum();
    this.getCareerDescriptionEnum()
    this.getEmailEnum()
  },
  methods: {
    formatVal(e){
      if(this.form.address.nationality_or_region_code != 1){
        return e.replace(/[\u4e00-\u9fa5]/g, '');
      }else{
        return e;
      }
    },
    checkCountry(e) {
      if(this.form.address.nationality_or_region_code != e.id){
        this.form.address.nationality_or_region_code= e.id;
        this.form.address.nationality_or_region_name = e.name;
        this.form.address.province_code = '';
        this.form.address.province_name = '';
        this.form.address.city_code = '';
        this.form.address.city_name = '';
        this.form.address.country_code = '';
        this.form.address.country_name = '';
        this.form.address.detail_address = '';
        this.form.address.otherAffiliation = ''
      }
      this.checkCountryNameDialog = false;
    },
    checkCountryDialog() {
      if(!this.isCanChange && this.extra_update_status != 1) return;
      this.checkCountryNameDialog = true;
    },
    getCareerAttributesEnum(){
      const params = {
        key:'careerAttributes'
      }
      this.$apis.getEnum(params).then(res =>{
        if(res){
          this.careerAttributesList = res.map(e => {
            e.text = e.value_display
            return e;
          })
        }
      })
    },

    getCareerDescriptionEnum(){
      const params = {
        key:'careerDescription'
      }
      this.$apis.getEnum(params).then(res =>{
        if(res){
          this.careerDescriptionList = res.map(e => {
            e.text = e.value_display
            return e;
          })
        }
      })
    },
    getData() {
      this.$apis.accountSituationV2({ step_code: '1' }).then(async (res) => {
        try {
          this.countryNameList = await this.$apis.getAllCountryList();
        }catch (e){

        }
        const { get_open_account_info, pending_profile, pending_commit_source } = res;
        this.pending_profile = pending_profile;
        this.pending_commit_source = pending_commit_source;
        const { address, email, job_type, job_age, address_img, job_type_other_describe, education,company,vocation_attribute, otherAffiliation, vocation, company_phone, company_address, open_status, info_extend_many,extra_update_status } = get_open_account_info;
        if(address){
          this.form.address = JSON.parse(address)
          
        }
        this.form.open_user_info.email = email;
        this.form.address_img = address_img;
        this.addressImgBase64 = address_img;
        this.form.open_user_info.education = education;
        this.form.open_user_info.job_type = job_type;
        this.form.open_user_info.job_age = job_age;
        this.form.open_user_info.company = company;
        this.form.open_user_info.vocation_attribute = vocation_attribute;
        this.form.open_user_info.vocation = vocation;
        this.form.open_user_info.company_phone = company_phone;
        this.form.open_user_info.company_address = company_address;
        this.open_status = open_status;
        this.form.otherAffiliation = otherAffiliation || '';
        this.form.open_user_info.job_type_other_describe = job_type_other_describe;
        this.extra_update_status = extra_update_status

        // 资金、住宅、账户状况赋值
        if ( info_extend_many && Array.isArray(info_extend_many) && info_extend_many.length ) {
          this.updateAccountInfo((info_extend_many[0]?.examine_list?.financialSituation) || []);
        }
        // 获取元素
        this.getElement();
      })
    },
    // 获取被拒账户资料
    getAuditMaterials() {
      this.$apis.getAuditMaterials().then( res => {
        this.form.address = res.address;
        this.form.open_user_info = res.open_user_info;
        this.form.otherAffiliation = res.otherAffiliation || '';
        this.extra_update_status = res.extra_update_status;
        this.open_status = res.open_status;
        this.pending_profile = res.pending_profile;
        this.pending_commit_source = res.pending_commit_source;
        if ( res.address_img ) {
          this.form.address_img = res.address_img.url;
          this.addressImgBase64 = res.address_img.url;
        }
        this.updateAccountInfo(res.financialSituation);
      })
    },
    // 更新账户信息
    updateAccountInfo(financialData = []) {
      financialData.forEach( (item, index) => {
        this.financialSituation[index].value = item.value;
        // 资金其它输入框赋值
        if ( item.type == "inputCheckbox" ) {
          this.financialSituation[index].options[this.financialSituation[index].options.length - 1].inputValue = item.options[item.options.length - 1].inputValue;
        }
        // 住宅单选框赋值
        if ( item.type == "multiSelect" ) {
          item.options.forEach( (cItem, cIndex) => {
            this.financialSituation[index].options[cIndex].children.value = cItem.children.value;
          })
        }
      })
    },
    getElement() {
      this.$nextTick(() => {
        const ele = document.querySelector('.email');
        this.topDistance = ele?.offsetHeight || 0;
        this.dialogWidth = ele?.offsetWidth + 2 || 0;
      })
    },
    getEmailEnum(){
      const params = {
        key:'emailSuffix'
      }
      this.$apis.getEnum(params).then(res =>{
          if(res){
            const email = res['0']?.value_display?.split(',') || []
            this.emailSuffixList = email
            this.resultEmail = email
          }
      })
    },
    openActions(key, options, index) {
      if(!this.isCanChange && this.extra_update_status != 1) return;
      this.pickerActionsKey = key;
      if (options && options.length > 0) {
        // Vant Picker 用 v-html 渲染，`<HKD...` 会被当成标签吃掉
        this.pickerActions = options.map(option => ({
          ...option,
          text: String(option.text || "").replace(/</g, "&lt;")
        }));
        // 查出选中的index下标
        this.currentDefaultIndex = options.findIndex(option =>
          option.value === this.financialSituation[index].value
        );
      } else {
        const actions = {
          job_type: this.$t("personalInformation.employment_field.columns"), // 职业状况
          education: this.$t("personalInformation.education_field.columns"), // 最高学历
          job_age: this.$t("personalInformation.employment_duration_field.columns"),
          vocation_attribute: this.careerAttributesList,
          job_type_other_describe: this.careerDescriptionList
        };
        this.pickerActions = actions[key];
        // 查出选中的index下标
        this.currentDefaultIndex = actions[key].findIndex(option =>
          option.value == this.form.open_user_info[key]
        );
      }
      this.isShowPicker = true;
    },
    onEducationalConfirm(e) {
      const { pickerActionsKey } = this;
      if (pickerActionsKey.indexOf("financialSituation_") >= 0) {
        
        const _index = pickerActionsKey.split("financialSituation_")[1];
        this.financialSituation[_index].value = e.value;
      } else {
        this.form.open_user_info[pickerActionsKey] = e.value;
        // 职业不同的情况下清空所选
        if (pickerActionsKey === 'job_type') {
          const fields = [
            'company',
            'company_address',
            'company_phone',
            'vocation',
            'vocation_attribute',
            'job_age'
          ];
          // 受雇、自雇情况下清空其它
          if ([1, 2].includes(e.value)) {
            this.form.open_user_info.job_type_other_describe = '';
          } else {
            // 非自雇、受雇清空下均清空fields的内容
            fields.forEach(field => {
              this.form.open_user_info[field] = '';
            });
            // 退休以及学生情况下情况其它
            if ([3, 4].includes(e.value)) {
              this.form.open_user_info.job_type_other_describe = '';
            }
            // 选中其他的情况下 需要默认选中自由投资者
            if ( e.value == 5 ) {
              this.form.open_user_info.job_type_other_describe = 'careerDescription1';
            }
          }
        }
      }
      this.isShowPicker = false;
    },
    openAreaPopup(){
      if(!this.isCanChange && this.extra_update_status != 1) return;
      this.$apis.getAddressLists().then(res=>{
        const lang = localStorage.getItem('localLang');
        let key = 'en';
        if(lang != 'en'){
          key = 'zh';
        }
        if(this.form.address.nationality_or_region_code != 1){
          key = 'en';
        }
        this.areaList = res[key];
        this.showAreaPopup = true;
      })
    },
    confirmArea(e){
      this.form.address.province_code = e[0]?.code;
      this.form.address.province_name = e[0]?.name;
      this.form.address.city_code = e[1]?.code;
      this.form.address.city_name = e[1]?.name;
      this.form.address.country_code = e[2]?.code;
      this.form.address.country_name = e[2]?.name;
      this.showAreaPopup = false;
    },
    afterRead(e){
      
      this.addressImgBase64 = e.base64;
      this.form.address_img = e.content;
    },
    delImg(){
      if(!this.isCanChange && this.extra_update_status != 1) return;
      this.addressImgBase64 = '';
      this.form.address_img = '';
    },
    changeResidence(e){
      this.financialSituation[4].options.forEach((item, i) => {
        if ( item.value != this.financialSituation[4].value ) {
          item.children.value = ''
        }
      });
    },
    beforeClose(action, done) {
      done(false);
    },
    confirm(done) {
      if (this.checkPassword === "") {
        Toast(this.$t("fail_reason.checkPasswordTips"));
        done(false);
      } else {
        this.$apis
          .checkPasswordFail({
            password: this.checkPassword
          })
          .then((res) => {
            done(false);
            // this.checkPasswordShow = false;
            if (res.code) {
              done(false);
              if (res.code === 100174 || res.code === 100173) {
                this.pwdErrPromptOption.errCode = res.code;
                this.pwdErrPromptOption.errHtml = res.data.err_msg.h5;
                this.pwdErrPromptOption.show = true;
                this.$refs["password-error-prompt-el"].show = true;
                done(false);
              }
            }else{
              //   提交 下一步
              // this.handleSaveSupplement();
              this.handleConfirmationData();
              done();
            }
          });
      }
    },
    async handleBeforeClose(action, done) {
      // 取消直接关闭弹窗
      if ( action != 'confirm' ) {
        this.checkPasswordShow = false;
        done()
        return false;
      }
      // 确认带上done，作用是控制弹窗是否关闭 done(false)不允许关闭
      this.confirm(done);
    },
    passwordErrorPromptConfirm(errCode) {
      this.pwdErrPromptOption.show = false;
      if (errCode === 100173) {
        this.checkPasswordShow = true;
        this.$refs["custom-field-password"].setInputFocus();
        setTimeout(() => {
          this.$refs["custom-field-password"].setInputFocus();
        }, 500);
      }
    },
    eyeSwitch() {
      this.eyeIsOpen = !this.eyeIsOpen;
    },
    toChangeInfo(){
      // 场景A：存在待审核 且 来源是【后台提交】，轻提示拦截，不可继续操作修改
      if (this.pending_profile == '1' && this.pending_commit_source == '2') {
        Toast(this.$t('accountProfile.a000029'));
        return;
      }

      // 场景B：存在待审核 且 来源是【APP提交】，弹窗询问是否覆盖
      if (this.pending_profile == '1' && this.pending_commit_source == '1') {
        Dialog.confirm({
          className: this.bgColor == 'black-theme' ? 'black-theme-dialog' : '',
          message: this.$t('accountProfile.a000030'),
        }).then(() => {
          // 用户点击【是】：允许进入资料修改
          this.pending_cover_choice = '1';
          this.isCanChange = true;
        }).catch(() => {
          // 用户点击【否】：不改资料，直接进入加开流程，确认页展示"有改资料"文案
          this.pending_cover_choice = '2';
          this.form.financialSituation = this.financialSituation;
          this.reportData();
        });
        return;
      }

      // 场景C：不存在待审核，正常进入资料修改页面
      this.isCanChange = true;
    },
    toNextPage(){
      this.$router.push({
        path: '/open-account/tradingVariety',
        query: {
          ...this.$route.query,
          add: 1
        }
      })
    },
    fundSourceChange(arr) {
      
      // 如果 arr 包含 6，则直接返回，不执行后续逻辑
      if (arr.includes(6)) return;
      // 获取 financialSituation 数组最后两个元素
      const lastTwoItems = this.financialSituation.slice(-2);
      // 遍历这最后两个元素
      lastTwoItems.forEach(item => {
        if (item.type === "inputCheckbox") {
          // 直接修改 options 数组最后一个元素的 inputValue 属性
          const lastOption = item.options[item.options.length - 1];
          lastOption.inputValue = '';
        }
      });
    },
    handleConfirmationData(){
      if(this.extra_update_status == 1){ 
        const saveParams = {
          process_id: 4,
          step_code: 'extra_data',
          step_order: 1,
          config_data: this.form,
          isChange: this.isCanChange ? 1 : 0
        }
        if (this.pending_cover_choice !== '') {
          saveParams.overwrite = this.pending_cover_choice === '1' ? 1 : 0;
        }
        this.$apis
          .supplementSaveApi(saveParams).then(res => {
          Dialog.alert({
            className:this.bgColor == 'black-theme' ? 'black-theme-dialog' : '',
            message: this.$t('suitabilitySurvey.s000005'),
          }).then(() => {
            closeWebView()
          });
          return
        })
      }else{
        this.reportData()
      }
    },
    handleSaveSupplement() {
      const params = {
        ...this.form
      };

    this.$apis
        .saveSupplement(params)
        .then(() => {
        })
        .catch(e => {
          
        });
    },
    reportData() {
      
      const params = {
        extra_data:{...this.form},
        open_server:{server_id:this.$route.query.openType || 3},
        isChange: this.isCanChange ? 1 : 0
      }
      const saveParams = {
        process_id: 4,
        step_code: 'extra_data',
        step_order: 1,
        config_data: params,
        isChange: this.isCanChange ? 1 : 0
      }
      if (this.pending_cover_choice !== '') {
        saveParams.overwrite = this.pending_cover_choice === '1' ? 1 : 0;
      }
      this.$apis
        .supplementSaveApi(saveParams).then(res => {
          if ( res.code == 10059 ) {
            Toast(res.msg);
            return
          }
          this.toNextPage();
        })
    },
    next(){
      this.isClickNext = true;
      if ( this.computeButtonDisabled ) return false;
      this.form.financialSituation = this.financialSituation;
      if(this.isCanChange || this.extra_update_status == 1){
        // 校验邮箱
        if(!isEmail(this.form.open_user_info.email)){
          return Toast( this.$t('personalInformation.error_tip.lang13'))
        }
        this.checkPasswordShow = true;
      }else{
        // isCanChange为false，确认资料时根据待审核状态处理
        // 场景A：存在待审核 且 来源是【后台提交】，拦截，不进加开流程
        if (this.pending_profile == '1' && this.pending_commit_source == '2') {
          Toast(this.$t('accountProfile.a000029'));
          return;
        }
        // 场景B：存在待审核 且 来源是【APP提交】，直接进入加开，overwrite:1
        if (this.pending_profile == '1' && this.pending_commit_source == '1') {
          this.pending_cover_choice = '1';
          this.reportData();
          return;
        }
        // 场景C：不存在待审核，直接进入加开，overwrite:0
        this.pending_cover_choice = '2';
        this.reportData();
      }
    },
    getFullAddress() {
      const { province_name, city_name, country_name } = this.form.address;
      return [province_name, city_name, country_name]
        .filter(name => name)
        .join("-");
    },
    handSuffixClick(item){
      if(this.form.open_user_info.email.indexOf('@') > -1){
        this.form.open_user_info.email = `${this.form.open_user_info.email.split('@')[0]}${item}`
      }else{
        this.form.open_user_info.email = `${this.form.open_user_info.email}${item}`
      }
    },
    handEmailSuffix(e) {
      this.form.open_user_info.email = e.trim();
      const emailParts = e && e.split('@');
      let filteredDomains = [];

      if (emailParts && emailParts.length === 2) {
        const domain = emailParts[1];
        filteredDomains = this.resultEmail.filter(item => item.includes(domain));
        this.emailSuffixList = filteredDomains;
      }
      this.emailSuffixShow = Boolean(filteredDomains.length && this.form.open_user_info.email);
    },
    blurEvent() {
      this.emailSuffixShow = false;
    }
  }
};
</script>

<style lang="less" scoped>
.account-profile {
  padding: 22px 32px 180px;
  background: white;
}
.address-box{
  margin-bottom: 24px;
  .title{
    font-size: 32px;
    color: #17161C;
    font-weight: 500;
    margin-bottom: 24px;
  }
}
.ipt-box {
  margin-bottom: 24px;
  &.errorBox {
    .error {
      display: block;
    }
    .ipt-main {
      &:after{
        border-color: #fd2626 !important;
      }
    }
  }
  .ipt-main {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 20px 32px;
        min-height: 56px;
        position: relative;
        .overlay {
          z-index: 9999;
          position: absolute;
          /deep/ &.van-overlay {
            background-color: transparent !important;
          }
          .symbolList-box {
            max-height: 300px;
            overflow-y: auto;
            background: #ffffff;
            border-radius: 8px;
            box-shadow: 0px 0px 12px 0px rgba(23,22,28,0.08);
            padding: 0px 32px;
            .cell-box{
              padding: 30px 0px;
              background: #FFFFFF;
            }
          }
        }
        &:after{
          content: '';
          position: absolute;
          margin-top: -1px;
          top: -50%;
          left: -50%;
          width: 200%;
          height: 200%;
          border: 1px solid rgba(23, 22, 28, 0.25);
          transform: scale(0.5);
          border-radius: 20px;
        }
        .val-box {
          position: relative;
          z-index: 3;
          flex: 1;
          display: flex;
          flex-direction: column;
          line-height: 1;
          font-size: 32px;
          @keyframes labelAni{
            0%{
              font-size: 28px;
            }
            100%{
              font-size: 24px;
            }
          }
          .label {
            color: #747377;
            padding: 4px 0 20px;
            font-size: 24px;
            transform: translate3d(0,0,0);
            animation: labelAni .2s .1s linear both;
            &.placeholder {
              padding-bottom: 0;
              // padding: 12px 0 6px 0;
               font-size: 28px;
              animation: none;
            }
          }
          ::v-deep .van-cell {
            min-height: 0px;
            font-size: 32px;
            line-height: 32px;
            input{
              &::placeholder {
                font-size: 28px;
                color: #747377;
                font-weight: normal;
              }
              &:focus ~ .van-field__body{
                background: red;
              }
            }
            textarea {
              font-size: 32px;
              line-height: 35px;
              min-height: 70px;
              color: #17161c;
            }
          }
          .val {
            padding: 0;
            line-height: 36px;
            color: #17161c;
            font-weight: 500;
          }
        }
        .icon-arrow {
          width: 32px;
          height: 32px;
          background: url("../../../assets/images/arrow-down.png") no-repeat;
          background-size: 100% 100%;
        }
      }

  .error {
    display: none;
    margin-top: 12px;
    color: #fd2626;
    font-size: 24px;

    &.show {
      display: block;
    }

    &.right {
      text-align: right;
    }
  }

  &.error {
    .ipt-main {
      border-color: #fd2626;
    }

    .error {
      display: block;
    }
  }
}

.date-title{
  line-height: 100px;
  text-align: center;
  font-size: 32px;
  font-weight: 500;
}
.funding-source {
  padding: 38px 0 52px;
  margin-bottom: 0px;
  .subTitle {
    margin-bottom: 32px;
    color: #17161C;
    font-size: 32px;
    line-height: 32px;
    font-weight: bold;
  }

  .checkbox-container {
    display: flex;
    flex-wrap: wrap;
    // gap: 10px;
    margin-bottom: 26px;
    .checkbox-item {
      width: 48%;
      margin-bottom: 32px;
      &:nth-last-child(-n+2) {
        margin-bottom: 0px;
      }
    }
  }
}
.residence{
  .subTitle {
    margin-bottom: 32px;
    color: #17161C;
    font-size: 32px;
    line-height: 32px;
    font-weight: bold;
  }

  .residence-options {


    .option-group {
      display: flex;

      .mainRadio {
        margin-right: 60px;
      }

      .subRadio {
        width: 220px;
      }

      &:first-child {
        margin-bottom: 30px;
      }
    }

    .sub-options {
      margin-top: 30px;
      margin-left: 40px;
    }

    .van-radio-group {
      display: flex;
      gap: 40px;
    }
  }
}
.check-password-dialog{
  ::v-deep .custom-field-cell{
    margin: 20px 32px;
  }
  /deep/ .van-dialog__footer {
    padding: 0px !important;
  }
}
/deep/ .van-field__control:disabled {
  color: #17161C !important;
  -webkit-text-fill-color:#17161C;
}
/deep/ .van-checkbox__label {
  color: #17161C !important;
}
/deep/ .van-checkbox__icon.van-checkbox__icon--checked .van-icon.van-icon-success {
  background-color: #1c0955;
  border-color: #1c0955;
}
/deep/ .van-radio__label--disabled {
  color: #17161C !important;
}
.black-theme {
  .account-profile {
    background: #1B1C24 !important;
    .ipt-main {
      border-color:  rgba(255,255,255,0.45);
      .label {
        color: #9D9D9F;
      }
      .val {
        color: white;
      }
      /deep/ .van-field__control {
        color: white !important;
      }
      /deep/ .van-field__control:disabled {
        color: white !important;
        -webkit-text-fill-color: white !important;
      }
    }
    /deep/ .van-radio__label--disabled {
      color: white !important;
    }
    .funding-source {
      .subTitle {
        color: white;
      }
    }
    .residence {
      .subTitle {
        color: white;
      }
    }
    .address-box {
      .title {
        color: white;
      }
    }
    /deep/ .van-checkbox__icon.van-checkbox__icon--checked .van-icon.van-icon-success {
      background-color: #1989fa;
      border-color: #1989fa;
    }
    /deep/ .van-radio__icon--checked .van-icon {
      background-color: #1989fa;
      border-color: #1989fa;
    }
    /deep/ .van-checkbox__label {
      color: white !important;
    }
    /deep/ .van-radio__label {
      color: white;
    }
  }
  .ipt-box{
    &.focus{
      .ipt-main{
        &:after{
          border-color: rgba(255,255,255,0.25);
        }
      }
    }
    &.error{
      .ipt-main{
        &:after{
          border-color: #fd2626;
        }
      }
    }
    .ipt-main{
      &:after{
        border-color: rgba(255,255,255,0.25);
      }
      .label{
        color: #9D9D9F;
      }
      .icon-arrow{
        background: url("../../../assets/images/open-account/dark_icon.png") no-repeat;
        width: 32px;
        height: 32px;
        background-size: 100% 100%;
      }
      .val{
        color: #fff;
        ::v-deep{
          .van-cell__value input::placeholder {
            color: #9D9D9F !important;
          }
          textarea{
            color: #fff;
          }
        }
      }
    }
  }
  .van-dialog {
    background: #1B1C24 !important;
    /deep/ .van-dialog__header {
      color: white;
    }
    /deep/ .van-dialog__message {
      color: white;
    }
    /deep/ .van-button__content {
      color: white;
    }
    /deep/ .van-button--default {
      background: #1B1C24 !important;
    }
    /deep/ .box-row {
      color: white !important;
    }
  }
  .check-password-dialog{
    ::v-deep {
      .van-dialog__footer{
        .van-button{
          color: #fff;
          background: #8E92A3 !important;
          & + .van-button{
            background: #377CFB !important;
          }
        }
      }
    }
  }
  .symbolList-box {
    background-color: #14151D !important;
    .cell-box{
      background: #14151D !important;
      color: #FFFFFF;
    }
  }
  .darkClose, .darkOpen {
    display: block !important;
  }
}
.check-password-dialog{
    padding: 56px;
    width: 488px;
    ::v-deep {
      .van-dialog__header{
        padding-top: 0;
        font-size: 36px;
        font-weight: 500;
        color: #17161C;
      }
      .van-dialog__content{
        margin-top: 32px;
      }
      .verifyLoginPassword{
        margin: 0;
      }
      .van-dialog__footer{
        margin-top: 48px;
        &:after{
          display: none !important;
        }
        .van-button{
          background: rgba(15,15,47,0.04);
          border-radius: 100px;
          color: #17161C;
          height: 100px;
          font-size: 28px;
          & + .van-button{
            margin-left: 24px;
            background: #17161C;
            color: #fff;
            font-weight: 500;
            &:before,&:after{
              display: none;
            }
          }
          .van-button__text {
            font-weight: 500;
          }
        }
      }
    }
  }
  .verifyLoginPassword {
    margin: 20px;
    .input {
      height: 80px;
      font-size: 28px;
      border: 1px solid #F3F3F3;
      border-radius: 16px;
      /deep/ .van-field__button {
        display: flex;
        align-items: center;
      }
    }
    .eye {
      width: 50px;
      height: 50px;
      display: none;
    }
  }
// icon
.img-icon{
  width: 28px;
  height: 28px;
}
@supports (-webkit-touch-callout: none) {
  .img-icon {
    transform: translateY(-2px);
  }
}
.address-popup{
  border-radius: 32px 32px 0 0;
  ::v-deep .van-picker{
    //border-radius: 32px 32px 0 0;
    .van-picker__toolbar{
      padding-top: 32px;
    }
    .van-picker__cancel {
      font-size: 32px;
    }
    .van-picker__confirm {
      font-size: 32px;
    }
  }
}
.white-theme {
  .lightClose, .lightOpen {
    display: block;
  }
}
.check-country {
  width: 100%;
  height: 100vh;
  border-radius: 0;
  z-index: 9999 !important;
  display: flex;
  flex-direction: column;
  .dialog-head {
    height: 100px;
    display: flex;
    padding: 0 100px;
    position: relative;
    .btn-back {
      position: absolute;
      left: 0;
      top: 0;
      height: 100px;
      width: 100px;
      background: url("../../../assets/images/arrow-right.png") no-repeat center;
      background-size: 48px 48px;
      transform: rotateY(180deg);
    }
    .dialog-title {
      flex: 1;
      text-align: center;
      font-size: 32px;
      color: #17161c;
      line-height: 100px;
    }
  }
  .input-box {
    padding: 0 32px;
    ::v-deep .van-cell {
      border-radius: 75px;
      background: #f7f8fa;
      min-height: 75px;
    }
  }
  .list {
    margin-top: 20px;
    flex: 1;
    position: relative;
    .list-main {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      overflow-y: scroll;
      .item {
        line-height: 80px;
        padding: 0 32px;
        border-bottom: 1px solid rgba(23, 22, 28, 0.1);
        font-size: 28px;
        color: #323233;
        display: flex;
        justify-content: space-between;
        align-items: center;
        &.cur {
          color: #ff9275;
        }
      }
    }
  }
}
</style>
